import { createFileRoute } from '@tanstack/react-router';

/**
 * Refer a Friend now lives in New Client Offer as "Friends of your clients"; the old addresses only redirect there
 * (`referrals/` → Overview's friends results, `referrals/setup` → the Setup friends card), so bookmarks still work.
 */
export const Route = createFileRoute('/_auth/$orgId/marketing/referrals')({});
